import { Component, OnInit, ViewChild } from '@angular/core';
import { UserProfile } from 'src/app/Models/user-profile';
import { UserInfo } from 'src/app/Models/user-info';
import { Category } from 'src/app/Models/category';
import { Policy } from 'src/app/Models/policy';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PolicyService } from 'src/app/Services/policy.service';
//import { UserService } from 'src/app/Services/user.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { UsernamePasswordClient } from '@azure/msal-common';
import { MatTableFilter } from 'mat-table-filter';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.css']
})
export class PolicyComponent implements OnInit {
  // userProfile : UserProfile;
  // currentUserInfo : UserInfo;
  // userType: string;
  // userName: string;
  categoryList : Category[];
  policyList;
  datasource;
  policyList_filter = new MatTableDataSource<Policy>;
  private apiCall = '/getcategorypolicylist/';
  selectedCategoryID : string;
  filterType: MatTableFilter;
  filterEntity:Policy;

  offlineClicked: boolean = false;
  color:string="";

  displayedColumns : string[] = ["category", "title", "policyNumber", "policyNumberFormer"];

  @ViewChild(MatPaginator, {static: false})
  set paginator(value: MatPaginator) {
    if (this.datasource){
      this.datasource.paginator = value;
    }
  }

  @ViewChild(MatSort, {static: false})
  set sort(value: MatSort) {
    if (this.datasource){
      this.datasource.sort = value;
    }
  }

 constructor(private policyService: PolicyService) {
    }

  ngOnInit(): void {
    // this.currentUserInfo = this.userService.getCurrentUesrInfo();
    // if (this.currentUserInfo !== undefined && this.currentUserInfo !== null && Object.keys(this.currentUserInfo).length > 0) {
    //   this.userType = this.currentUserInfo.userType;
    //   this.userName = this.currentUserInfo.userName;
    // }
    // else {
    //   this.userType = "null";
    //   this.userName = "null";
    // }
    this.getCategoryPolicies("0");
    //this.policyList.sort = this.sort;
    //this.policyList.paginator = this.paginator;

    this.filterType = MatTableFilter.ANYWHERE;
    if (this.datasource !== undefined) {
      this.datasource.filterPredicate = function (record,filter) {
        return record.title.toLocaleLowerCase() == filter.toLocaleLowerCase();
      }  
    }

    //this.getCurrentUserInfo();
  }

  // filterTable() {
  //   this.policyList.filterPredicate = (data: Policy, filter: string): boolean => {
  //     return (
  //       data.title.toLocaleLowerCase().includes(filter)
  //     )
  //   }
  // } 

  getCategoryPolicies(categoryID) {
    this.policyList = null;
    this.categoryList = null;
    this.selectedCategoryID = categoryID;
    this.offlineClicked = false;
    this.color = "#187db8";
    
    // if (this.currentUserInfo === null)
    // {
    //   this.userName = "null";
    // }
    // else {
    //   this.userName = this.currentUserInfo.userPNumber;
    // }
    this.policyService.getCategoryPolicies(this.apiCall, categoryID).subscribe(
      data => {
        if (categoryID !== '0') {
          this.policyList = data['policies'].filter(item => item.active == "Active" && item.categoryID == categoryID);
          this.datasource = new MatTableDataSource(this.policyList);
          this.datasource.sort = this.sort;
          if (this.paginator === undefined) {
            console.log("pagenator is undefined");
          }
          this.datasource.paginator = this.paginator;
        }
        else {
          this.policyList = data['policies'].filter(item => item.active == "Active");
          this.datasource = new MatTableDataSource(this.policyList);
          this.datasource.sort = this.sort;
          this.datasource.paginator = this.paginator;
        }
        this.categoryList = data['categories'].filter(item => item.active == 'Active');
      }
    );
  }

  getCategoryPolicies_Offline(categoryID) {
    this.offlineClicked = true;
    this.policyList = null;
    this.categoryList = null;
    this.selectedCategoryID = categoryID;
    this.color = "rgb(151, 150, 150)";
    // if (this.currentUserInfo === null)
    // {
    //   this.userName = "null";
    // }
    // else {
    //   this.userName = this.currentUserInfo.UserPNumber;
    // }
    //this.apiCall = "/getcategorypolicylist/";
    this.policyService.getCategoryPolicies(this.apiCall, '0').subscribe(
      data => {
        //console.log("get category and policy data: " + JSON.stringify(data));
        if (categoryID !== '0') {
          this.policyList = data["policies"].filter(item => item.offline == 1 && item.categoryID == categoryID);
          this.datasource = new MatTableDataSource(this.policyList);
          this.datasource.sort = this.sort;
          if (this.paginator === undefined) {
            console.log("pagenator is undefined");
          }
          this.datasource.paginator = this.paginator;
        }
        else {
          this.policyList = data["policies"].filter(item => item.offline == 1);
          this.datasource = new MatTableDataSource(this.policyList);
          this.datasource.sort = this.sort;
          this.datasource.paginator = this.paginator;
        }
        this.categoryList = data["categories"].filter(item => item.active == 'Active');
      }
    );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.datasource.filter = filterValue.trim().toLowerCase();
  }
}

